import { getHasAppCertificationCredential } from 'marketplace-ui-apps-core/common/utils/Certification';
import styled from 'styled-components';
import { EcosystemAppCard } from 'trellis-ecosystem';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { getListingDetailUrl } from '../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledRouterLink = styled(UIRouterLink).withConfig({
  displayName: "ResultCard__StyledRouterLink",
  componentId: "f2lh1a-0"
})(["display:grid;"]);
const ResultCard = ({
  onClick,
  result,
  referrer
}) => {
  const {
    companyName,
    credentials,
    firstPublishedAt,
    iconUrl,
    installed,
    installsCount,
    name,
    slug,
    tagline
  } = result;
  return /*#__PURE__*/_jsx(StyledRouterLink, {
    "data-test-id": "result-card",
    onClick: onClick,
    to: getListingDetailUrl(slug, referrer),
    use: "unstyled",
    children: /*#__PURE__*/_jsx(EcosystemAppCard, {
      appName: name,
      certified: getHasAppCertificationCredential(credentials),
      firstPublishedAt: firstPublishedAt,
      iconUrl: iconUrl,
      installCount: installsCount,
      installed: installed,
      layout: "grid",
      providerName: companyName,
      tagline: tagline
    })
  });
};
export default ResultCard;